<template>
    <div slot="content">
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `기본정보` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="goBack">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        뒤로가기
                        </button>
                        <span v-if="showSave">
                            <button class="btn-size btn-gray fl_left" @click="saveCampaignInfo">
                            <span class="btn-icon">
                                <i class="fas fa-save"></i>
                            </span>
                            {{btnSaveTitle}}
                            </button>
                            
                            <span v-if="form.campaignId > 0 && form.campaignStatus !='Complete' ">
                                <button class="btn-size btn-gray fl_left" @click="delCampaignInfo">
                                <span class="btn-icon">
                                    <i class="fas fa-save"></i>
                                </span>
                                캠페인 삭제
                                </button>
                            </span>
                        </span>
                        
                    </div>
                </div>
                
                <!-- 기본정보 폼 s-->
                <el-form ref="form" :model="form" label-width="80px" size="mini">
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="캠페인번호">
                                <el-input v-model="form.campaignId" readonly disabled style="width: 90%;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="캠페인명">
                                <el-input v-model="form.campaignNm" :readonly="!showSave" :disabled="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="시작일자">
                                <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd" :readonly="!showSave" :picker-options="datePickerOptions"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="종료일자">
                                <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd" :readonly="!showSave" :picker-options="datePickerOptions"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="진행단계" label-width="65px">
                                <el-row>
                                    <el-col :span="16">
                                        <el-input v-model="form.campaignStatusNm" readonly></el-input>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-checkbox label="진행중지" v-model="form.campaignStatus" true-label="Stop" false-label="" size="large" @change="stopCheck" />
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label="캠페인설명">
                                <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                placeholder="캠페인설명을 작성하세요."
                                v-model="form.description"
                                :readonly="!showSave">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                </el-form>
                <!-- 기본정보 폼 e -->
            </div>

            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `설문작성` }}</h3>
                    </div>
                    <span v-if="showSurveyDelete">
                        <div class="table-header">
                            <div class="btn-wrap btn-type1 clearfix">
                                <button class="btn-size btn-gray fl_left" @click="delQuestItem">
                                <span class="btn-icon">
                                    <i class="fas fa-save"></i>
                                </span>
                                삭제
                                </button>
                            </div>
                        </div>
                    </span>
                </div>
            
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="grid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        row-selection="single"
                        :context="context"
                        :column-defs="columnDefs"
                        :grid-options="mainGridOptions"
                        :row-data="data"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadyMain"
                        @cell-clicked="onCellClicked"
                        editType="fullRow" />
                </div>
            </div>

            <div class="table-b">
                <div class="table-header" v-if="showSurvey">
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="addQuestItem">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        추가
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="modQuestItem">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        수정
                        </button>
                        
                        <button class="btn-size btn-gray fl_left" @click="saveQuestItem">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        설문저장
                        </button>
                    </div>
                </div>

                <!-- 설문작성 폼 s-->
                <el-form ref="form" :model="form" label-width="55px" size="mini">
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label="질문">
                                <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                placeholder="질문을 작성하세요."
                                :readonly="!showSave"
                                v-model="subForm.questionDesc">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="답변1">
                                <el-input v-model="subForm.reply1Desc" :readonly="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="답변2">
                                <el-input v-model="subForm.reply2Desc" :readonly="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="답변3">
                                <el-input v-model="subForm.reply3Desc" :readonly="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="답변4">
                                <el-input v-model="subForm.reply4Desc" :readonly="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="답변5">
                                <el-input v-model="subForm.reply5Desc" :readonly="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="답변6">
                                <el-input v-model="subForm.reply6Desc" :readonly="!showSave"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                    
                    
                </el-form>
                <!-- 설문작성 폼 e -->

                
            </div>
        </div>
        
        <div class="table-area">
            <div class="table-a">
                <el-table
                    :data="campaignSumList">
                    <el-table-column prop="totalCnt" label="총건수" align="center" width="280"> </el-table-column>
                    <el-table-column prop="devideCnt" label="할당건수" align="center" width="280"> </el-table-column>
                    <el-table-column prop="nondevideCnt" label="미할당건수" align="center" width="280"> </el-table-column>
                    <el-table-column prop="doneCnt" label="완료건수" align="center" width="280"> </el-table-column>
                </el-table>
            </div>
        </div>
        
        <div class="grid-tbl-box">
            <ag-grid-vue 
                ref="subGrid" 
                :style="subGridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="subColumnDefs"
                :grid-options="subGridOptions"
                :row-data="subData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadySub"
                />
        </div>
         
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import NumberInputCellRender from '@/components/agGrid/numberinput-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import SelectCellRendererSecondary from '@/components/agGrid/select-cell-renderer-secondary';


/**
 * * Modal
 */
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import CSChgModal from '@/components/AS/NormalConsult/Modal/CSChgModal.vue';
import CallReadModal from '@/components/AS/NormalConsult/Modal/CallReadModal.vue';


/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            btnSaveTitle: '저장',
            form: {
                campaignId: '',
                campaignType: '',
                campaignNm: '',
                startDt: this.$moment().format('YYYY-MM-DD'),
                endDt: this.$moment().format('YYYY-MM-DD'),
                campaignStatusNm: '', /** 진행단계 */
                campaignStatus: '', /** 진행중지 */
                description: '',    /** 캠페인설명 */
                curCampaignStatus: ''
            },
            subForm:{
                chk:'N',
                questionDesc: '',
                reply1Desc: '',
                reply2Desc: '',
                reply3Desc: '',
                reply4Desc: '',
                reply5Desc: '',
                reply6Desc: ''
            },
            selIdx: -1, /** 선택한 index */
            combos: {
                'campaignStatus' : []
            },
            campaignSumList: [
                {
                    totalCnt: '',
                    devideCnt: '',
                    nondevideCnt: '',
                    doneCnt: ''
                }
            ], /** 총건수, 할당건수, 미할당건수, 완료건수 */
            showSave: false,
            showSurvey: false, /** 설문버튼 표시여부 */
            showSurveyDelete: false, /** 설문삭제버튼 표시여부 */
            callTypeRadio: [], /** 처리결과 */
            data: [],
            subData: [],
            
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 0px; width: 100%;height: 300px; min-height:100px;',
            subGridStyle : 'padding-top: 40px; width: 100%;height: 400px; min-height:100px;',
            context: {
                // context is used as a global variable
                editorUpdateMethods: {},
                editorRefs: {},
                getRefData: this.getRefData,
            },
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            mainGridApi: null,
            mainColumnApi: null,
            subGridApi: null,
            subColumnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            mainGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                maskEdit: MaskEditCellRenderer,
                select: SelectCellRenderer,
                checkBox: CheckboxCellRenderer,
                radio: RadioCellRenderer,
                numberInput: NumberInputCellRender,
                input: InputCellRender,
                button: ButtonCellRenderer,
                secondarySelect: SelectCellRendererSecondary,
            },
            topDownData: [],
            //AG-GRID OPTION [END]
            datePickerOptions: {
                disabledDate (date) {
                    return date < new Date('1971-01-01')
                }
            },
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        this.init();
        this.btnSaveTitle = '저장';
        if(this.$route.params.detailLinkYn==='Y'){
            // 상세페이지 클릭하여 페이지이동한 경우

            this.btnSaveTitle = '수정';
            this.form.campaignId = this.$route.params.campaignId;

            if(this.$route.params.campaignId===''){
                // campaignId 를 체크
                this.$swal({ type: 'warning', text: '해당 캠페인은 삭제된 캠페인입니다.' });
                return false;

            } else {
                this.selectItem();
            }
        } else {
            
            this.form.campaignType = 'Setisfaction';
        }

        this.isAuth();
        this.selectQuestItem();
        
    },
    methods: {
        onReadyMain() {
            this.mainGridApi = this.mainGridOptions.api;
            this.mainColumnApi = this.mainGridOptions.columnApi;
            this.createMainColumnDefs();
            
        },
        onReadySub() { 
            //메인그리드 api 정의
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
        },
        createMainColumnDefs() {
            const that = this;
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:50,
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName:'질문',
                    field:'questionDesc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'답변1',
                    field:'reply1Desc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'답변2',
                    field:'reply2Desc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'답변3',
                    field:'reply3Desc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'답변4',
                    field:'reply4Desc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'답변5',
                    field:'reply5Desc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'답변6',
                    field:'reply6Desc', 
                    width:250,
                    cellStyle:{textAlign: 'center'},
                }
                 
            ];
        },
        createSubColumnDefs() {
            this.subColumnDefs = [
                {
                    headerName: '상담원명', 
                    field:'userNm', /** 카테고리3레벨 */
                    width: 250,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '할당건수', 
                    field:'devideCnt', /** 카테고리4레벨 */
                    width: 250,
                    cellStyle:{textAlign:'right'}
                },
                {
                    headerName: '처리건수', 
                    field:'doneCnt', 
                    width: 250,
                    cellStyle:{textAlign:'right'}
                },
                {
                    headerName: '미처리건수', 
                    field:'nondoneCnt',
                    width: 250,
                    cellStyle:{textAlign:'right'}
                }
            ];
        },
        selectItem(param){
            console.log('selectItem Tab1: ', param);
            const vm = this;
            let vCampaignId = this.$route.params.campaignId || '';
            if(param){
                vCampaignId = param;
            } 
            
            const vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                ...this.form,
                campaignId: vCampaignId,
                startDt: this.form.startDt.replace(/[^0-9]/g, ''),
                endDt: this.form.endDt.replace(/[^0-9]/g, ''),
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            
            this.$store.commit('loading')
            console.log('selectItem vform : ', vform) 
            this.$http.post(("/api/workMng/happyCallManager/selectItem"), vform
                ).then(response => {
                 console.log('callMain SearchForm response.data' , response.data)

                 const vFormObj = 
                    response.data.uspCampaignSelItem.map(x=>{
                        if(x.startDt && x.startDt.length >= 10){
                            x.startDt = x.startDt.substring(0,10); 
                        }
                        if(x.endDt && x.endDt.length >= 10){
                            x.endDt = x.endDt.substring(0,10); 
                        }
                        
                        const vCampaignStatusObj = this.combos['campaignStatus'].filter(y=>y.key===x.campaignStatus);
                        
                        if(vCampaignStatusObj && vCampaignStatusObj.length>0){
                            x.campaignStatusNm = vCampaignStatusObj[0].value;
                        }

                        x.curCampaignStatus = x.campaignStatus;

                        return x;
                    });
console.log('vFormObj : ', vFormObj)
                 if(vFormObj && vFormObj.length>0){
                    this.campaignSumList  = 
                        [
                            {
                                totalCnt: vFormObj[0].totalCnt,
                                devideCnt: vFormObj[0].devideCnt,
                                nondevideCnt: vFormObj[0].nondevideCnt,
                                doneCnt: vFormObj[0].doneCnt
                            }
                        ];

                    this.form = vFormObj[0] || {};
                 }
                 
                 this.subData = response.data.uspCampaignCustSelDistripUser;

                
            }).finally(() => {
                this.$store.commit('finish')

                
            });
        },
        onGridReady(){
            
        },
        onCellClicked(params) {
            const idx = params.rowIndex;
            // const field = params.colDef.field;
            this.selIdx = idx;

            this.subForm = _.cloneDeep(params.data);
        },
        stopCheck(val){
            
            if(this.form.curCampaignStatus === 'Complete'){
                this.$swal({ type: 'warning', text: '캠페인이 종료되어서 중지할수가 없습니다.' });
                this.form.campaignStatus = ''; 
                
                return;
            }
 
            console.log('stopCheck  :', this.form.campaignStatus, val);
        },
        openModel(param) {
            /** 일반상담상세내역 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: CallReadModal,
                parent: this,
                props: {
                    data: {
                        callId: param.callId,
                        callTypeRadio: vm.callTypeRadio
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        openModal() {
            let vm = this;
            this.$modal.open({
                width: 800,
                component: CSChgModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        searchModel(){
            /** 모델선택 */
            let vm = this;
            this.$modal.open({
                width: 800,
                component: ModelSelectModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(param) {
                        console.log('close', param);
                        vm.form.maker = param.data.maker /** 제조사 */
                        vm.form.makerNm = param.data.makerNm /** 제조사명 */
                        vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                        vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
                        vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
                        vm.form.modelNm = param.data.modelNm /** 모델명 */
                        vm.form.modelId = param.data.modelId /** 모델ID */
                    },
                }
            });

        },
        async init() {
            
            this.$store.commit('loading');

            // 상태 : 해피콜진행상태
            await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 395}})
                .then(response => {
                    this.combos['campaignStatus'] = response.data || []
                })
                .finally(() => {});

            this.$store.commit('finish')

        },
        goBack(){
            // 리스트 조회화면으로 이동
            this.$router.push({          
                name: 'HappyCallManager',
                params: {
                    searchCond: {
                        ...this.$route.params
                    }
                }
            });
        },
        selectQuestItem(){
            // 설문문항 조회

            const vm = this;
            const vform = {
                campaignId: this.form.campaignId,
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            
            this.$store.commit('loading')
            console.log('selectItem vform : ', vform) 
            this.$http.post(("/api/workMng/happyCallManager/selectQuestItem"), vform
                ).then(response => {
                 console.log('selectQuestItemresponse.data : ' , response.data)
  
                 vm.data = response.data;
                //  vm.data = response.data.map(x=>{
                //     return {
                //         questionDesc : x.questionDesc,
                //         reply1Desc : x.reply1Desc,
                //         reply2Desc : x.reply2Desc,
                //         reply3Desc : x.reply3Desc
                //     }
                //  });

                //  vm.data = [{
                //     questionDesc : 'ddd',
                //     reply1Desc : '1'
                //  }];
                
            }).finally(() => {
                this.$store.commit('finish');
            });
        },
        saveCampaignInfo(){
            // 캠페인 기본정보 수정

            const vm = this;
            const vCampaignCustStatus = '';
 
            if(this.form.campaignNm === ''){
                this.$swal({ type: 'warning', text: '캠페인명을 입력해 주십시오.' });
                return false;
            }

            if(this.form.startDt === ''){
                this.$swal({ type: 'warning', text: '시작일자를 입력해 주십시오.' });
                return false;
            }

            if(this.form.endDt === ''){
                this.$swal({ type: 'warning', text: '종료일자를 입력해 주십시오.' });
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    const vform = {
                        ...vm.form,
                        campaignId : vm.form.campaignId || 0
                    }
                    
                    console.log('save ...vform: ', vform)             
                    vm.$store.commit('loading');
                    vm.$http.put(_url("/api/workMng/happyCallManager/saveCampaign"), vform)
                        .then(response => {
                            const vCampaignId = response.data;

                            if(vCampaignId && Number(vCampaignId)){
                                vm.$swal({ type: 'success', text: '기본정보가 저장되었습니다.' });

                                const params = 
                                    {
                                        campaignId: vCampaignId,
                                        startDt: vm.form.startDt || '',
                                        endDt: vm.form.endDt || ''
                                    }
                                vm.$parent.reloadPage(params);
                                
                                // vm.form.campaignId = vCampaignId;
                                // vm.selectItem(vCampaignId);
                                // vm.isAuth(); 

                                // if(vm.form.campaignId ==='') {
                                //     vm.goBack();
                                // }
                                
                            } else {
                                vm.$swal({ type: 'success', text: '기본정보가 저장에 실패했습니다.' });
                            }
                            
                        }).catch((e) => {
                            // console.error(e);
                            // vm.$swal({ type: 'success', text: '기본정보 저장에 실패했습니다' })
                        })
                        .finally(() => {
                            vm.$store.commit('finish');
                        });
                }
            });


        },
        delCampaignInfo(){
            // 캠페인 삭제

            const vm = this;
            const vCampaignCustStatus = '';
 
            this.$swal({
                type: 'warning',
                text: `삭제하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    const vform = {
                        ...vm.form,
                        campaignId : vm.form.campaignId || 0
                    }
                    
                    console.log('del ...vform: ', vform);
                    let vBackYn = 'N';             
                    vm.$store.commit('loading');
                    vm.$http.put(_url("/api/workMng/happyCallManager/delCampaign"), vform)
                        .then(response => {
                            const vCampaignId = response.data;

                            if(vCampaignId && Number(vCampaignId)){
                                vm.$swal({ type: 'success', text: '캠페인이 삭제되었습니다.' });
                                vBackYn = 'N';
                            } else {
                                vm.$swal({ type: 'success', text: '캠페인의 삭제에 실패했습니다.' });
                            }
                            
                        }).catch((e) => {
                            // console.error(e);
                            // vm.$swal({ type: 'success', text: '기본정보 저장에 실패했습니다' })
                        })
                        .finally(() => {
                            vm.$store.commit('finish');

                            if(vBackYn === 'N'){
                                vm.goBack();
                            }
                            
                        });
                }
            });


        },
        addQuestItem(){
            // 설문문항 추가
            if(this.subForm.questionDesc===''){
                this.$swal({ type: 'warning', text: '질문을 입력해주세요.' });
                return false;
            }

            if(this.subForm.reply1Desc===''){
                this.$swal({ type: 'warning', text: '답변을 입력해주세요.' });
                return false;
            }

            const vSubForm = {
                ...this.subForm,
                ioFlag: 'I'
            };

            this.data.push(_.cloneDeep(vSubForm));

            this.subForm.chk = 'N';
            this.subForm.questionDesc = '';
            this.subForm.reply1Desc = '';
            this.subForm.reply2Desc = '';
            this.subForm.reply3Desc = '';
            this.subForm.reply4Desc = '';
            this.subForm.reply5Desc = '';
            this.subForm.reply6Desc = '';
        },
        modQuestItem(){
            // 설문문항 수정

            const vm = this;

            if(this.selIdx === -1){
                this.$swal({ type: 'warning', text: '수정할 문항을 선택해주세요.' });
                return false;
            }

            if(this.subForm.questionDesc===''){
                this.$swal({ type: 'warning', text: '질문을 입력해주세요.' });
                return false;
            }

            if(this.subForm.reply1Desc===''){
                this.$swal({ type: 'warning', text: '답변을 입력해주세요.' });
                return false;
            }

            this.data = this.data.map((x,index)=>{
                if(index===vm.selIdx){
                    x.questionDesc = vm.subForm.questionDesc;
                    x.reply1Desc = vm.subForm.reply1Desc;
                    x.reply2Desc = vm.subForm.reply2Desc;
                    x.reply3Desc = vm.subForm.reply3Desc;
                    x.reply4Desc = vm.subForm.reply4Desc;
                    x.reply5Desc = vm.subForm.reply5Desc;
                    x.reply6Desc = vm.subForm.reply6Desc;
                }
                return x;
            });

            this.subForm.questionDesc = '';
            this.subForm.reply1Desc = '';
            this.subForm.reply2Desc = '';
            this.subForm.reply3Desc = '';
            this.subForm.reply4Desc = '';
            this.subForm.reply5Desc = '';
            this.subForm.reply6Desc = '';
             
        },
        delQuestItem(){
            // 설문문항 삭제

            const vChkData = this.data.filter(x=>x.chk==='Y');

            if(vChkData && vChkData.length > 0){
                const vData = _.cloneDeep(this.data.filter(x=>x.chk==='N'));
                this.data = vData;
                this.selIdx = -1; // 초기화
                this.subForm.questionDesc = '';
                this.subForm.reply1Desc = '';
                this.subForm.reply2Desc = '';
                this.subForm.reply3Desc = '';
                this.subForm.reply4Desc = '';
                this.subForm.reply5Desc = '';
                this.subForm.reply6Desc = '';

            } else {
                this.$swal({ type: 'warning', text: '삭제할 문항을 선택해주세요.' });
                return false;
            }
            
        },
        saveQuestItem(){
            // 설문저장
            const vm = this;
            
            if(this.form.campaignId == '0' || this.form.campaignId == ''){
                this.$swal({ type: 'warning', text: '캠페인 기본정보를 저장후 설문작성을 하시기 바랍니다.' });
                return false;
            }else if(this.data && this.data.length===0){
                this.$swal({ type: 'warning', text: '설문을 작성후 저장하시기 바랍니다.' });
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `설문을 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    let vData = _.cloneDeep(this.data);
                    const vform = vData.map(x=>{
                        delete x.chk;
                        delete x.ioFlag;
                        x.campaignId = vm.form.campaignId;
                        
                        return x;
                    });
                    
                    console.log('save ...vform: ', vform)             
                    vm.$store.commit('loading');
                    vm.$http.put(_url("/api/workMng/happyCallManager/saveQuestItem"), vform)
                        .then(response => {
                            if(response.data === 'SURVEY_CUST_EXIST'){
                                vm.$swal({ type: 'warning', text: '이미 설문에 참여한 고객정보가 있어서 수정할 수가 없습니다.' });

                            } else {
                                vm.$swal({ type: 'success', text: '설문문항이 저장되었습니다.' });
                            }
                            
                            vm.isAuth(); 
                            vm.selectItem(vm.form.campaignId);
                            vm.selectQuestItem();

                            // vm.formClear();
                        }).catch((e) => {
                            console.error(e);
                            vm.$swal({ type: 'success', text: '기본정보 저장에 실패했습니다' })
                        })
                        .finally(() => {
                            vm.$store.commit('finish');
                        });
                }
            });
        },
        isAuth(){
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===89); // 해피콜관리(기본정보)
            this.showSave = false; // 입력권한
            
            this.showSurvey = false; // 
            this.showSurveyDelete = false; // 
            if(auth && auth.length > 0){
                this.showSave = auth[0].grantInsert === 'Y' ? true : false ;
                
                if(!(this.form.campaignId == '' || this.form.campaignId == '0')){
                    this.showSurveyDelete = auth[0].grantDelete === 'Y' ? true : false ;
                    this.showSurvey = true; // 
                }
            }
        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>